import axios from 'axios';
import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';

import { projectRequest } from 'store/utils/request';
import * as annotationsSelectors from 'store/services/annotations/selectors';

// eslint-disable-next-line import/no-cycle
import * as api from './api';
import * as types from './actionTypes';

/**
 * Annotate test set entries
 *
 * @param data
 * @param byUser
 * @returns {Function}
 */
export const annotate = (data, byUser = false) => async (
  dispatch,
  getState,
) => {
  try {
    dispatch({
      type: types.ANNOTATE_REQUEST,
    });

    const response = await api.annotateRequest({
      ...annotationsSelectors.getAnnotatorParams(getState()),
      ...data,
    });

    dispatch({
      type: types.ANNOTATE_SUCCESS,
      payload: {
        annotations: {
          results: response.data.results,
          matched_rules_map: response.data.matched_rules_map,
        },
        byUser,
      },
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }

    dispatch({
      type: types.ANNOTATE_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Cancel annotate
 */
export const CANCEL_ANNOTATE_ID = 'annotate';
export const cancelAnnotate = () => dispatch => {
  projectRequest.cancel(CANCEL_ANNOTATE_ID);

  dispatch({
    type: types.ANNOTATE_CANCEL,
  });
};

export const reset = () => ({
  type: types.ANNOTATE_RESET,
});

export const toggleAnnotationVisibility = id => ({
  type: types.TOGGLE_ANNOTATION_VISIBILITY,
  payload: {
    id,
  },
});

export const toggleAnnotationsVisibility = (enableAll = false) => ({
  type: types.TOGGLE_ANNOTATIONS_VISIBILITY,
  payload: {
    enableAll,
  },
});

export const selectAnnotatorResult = result => ({
  type: types.SELECT_ANNOTATOR_RESULT,
  payload: {
    result,
  },
});

export const deselectAnnotatorResult = () => ({
  type: types.DESELECT_ANNOTATOR_RESULT,
});

/* eslint-disable camelcase */
export const selectAnnotatorResultByID = id => (dispatch, getState) => {
  const result = annotationsSelectors
    .getAnnotations(getState())
    // eslint-disable-next-line @typescript-eslint/camelcase
    .find(({ test_entry_id }) => test_entry_id === id);

  if (result) {
    dispatch(selectAnnotatorResult(result));
  }
};

export const resetAnnotationsForTestSetEntry = testSetEntryId => dispatch => {
  dispatch({
    type: types.RESET_ANNOTATIONS_FOR_TEST_SET_ENTRY,
    payload: { testSetEntryId },
  });
};
